function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 0.25C4.62354 0.25 0.25 4.62354 0.25 10C0.25 15.3765 4.62354 19.75 10 19.75C15.3765 19.75 19.75 15.3765 19.75 10C19.75 4.62354 15.3765 0.25 10 0.25ZM10 1.875C14.4973 1.875 18.125 5.50269 18.125 10C18.125 14.4973 14.4973 18.125 10 18.125C5.50269 18.125 1.875 14.4973 1.875 10C1.875 5.50269 5.50269 1.875 10 1.875ZM10 5.125C8.21313 5.125 6.75 6.58813 6.75 8.375H8.375C8.375 7.46729 9.09229 6.75 10 6.75C10.9077 6.75 11.625 7.46729 11.625 8.375C11.625 8.99707 11.2251 9.54932 10.6348 9.74609L10.3047 9.84766C9.64136 10.0667 9.1875 10.7014 9.1875 11.3965V12.4375H10.8125V11.3965L11.1426 11.2949C12.3931 10.8792 13.25 9.69214 13.25 8.375C13.25 6.58813 11.7869 5.125 10 5.125ZM9.1875 13.25V14.875H10.8125V13.25H9.1875Z",
  fill: "black"
});

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.5f78d67d.svg";
export { ForwardRef as ReactComponent };